export class LogModel {
  public tipo:TIPOLOG = TIPOLOG.OTROS;
  public fecha:string = "";
  public usuario:string = "";
  public descripcion:string = "";
  public entidad:TIPOENTIDADES = TIPOENTIDADES.TIENDA;
  public idEntidad:string = "";
}

export enum TIPOLOG {
  PPTO = "PPTO",
  CREARMALLAEMPLE = "CREARMALLAEMPLE",
  ACTUALIZARMALLAEMPLE = "ACTUALIZARMALLAEMPLE",
  CREARMALLATIENDA = "CREARMALLATIENDA",
  ACTUALIZARHORARIOTIENDA  = "ACTUALIZARHORARIOTIENDA",
  OTROS = "OTROS",
  ACTUALIZARMALLATIENDA = "ACTUALIZARMALLATIENDA"

}

export enum TIPOENTIDADES {
  TIENDA = "TIENDA",
  COLABORADOR = "COLABORADOR",
  OTROS = "OTROS"
}
